export function formatNullable(value: unknown): string {
  if (value === null || value === undefined || value === "") {
    return "-"
  }

  return String(value)
}

export function formatBoolean(value: boolean | null | undefined): string {
  if (value === null || value === undefined) {
    return "-"
  }

  return value ? "Yes" : "No"
}

export function formatDate(value: string | null | undefined): string {
  if (!value) {
    return "-"
  }

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) {
    return "-"
  }

  return date.toLocaleDateString()
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) {
    return "-"
  }

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) {
    return "-"
  }

  return date.toLocaleString()
}

export function toIsoDateTime(value: string): string {
  return new Date(value).toISOString()
}
